<template>
  <div class="tw-w-32 tw-mt-8 tw-mb-4">
    <strong class="tw-font-medium tw-text-xs tw-font-sans tw-uppercase">Quantity</strong>
    <div class="tw-flex tw-w-full tw-justify-between tw-border-2 tw-bg-white">
      <div
        class="tw-text-white tw-p-2 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center"
        :class="quantity === 1 ? 'tw-bg-gray-light' : 'button-default'"
        @click="decreaseQuantity"
      >
        <div
          class="tw-w-4 tw-h-4 tw-flex tw-items-center"
        >
          <stihl-icon
            name="minus"
            class="tw-w-4 tw-h-4"
          />
        </div>
      </div>

      <div class="tw-text-sm tw-flex tw-items-center tw-justify-center">
        {{ quantity }}
      </div>
      <div
        class="button-default tw-text-white tw-p-2 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center mr-neg1"
        @click="increaseQuantity"
      >
        <div class="tw-w-4 tw-h-4 tw-flex tw-items-center">
          <stihl-icon
            name="cross"
            class="tw-w-4 tw-h-4 tw-rotate-45"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StihlIcon from './StihlIcon.vue';

export default {
  components: {
    StihlIcon
  },
  props: {
    quantity: {
      type: Number,
      required: true
    }
  },
  methods: {
    decreaseQuantity() {
      if (this.quantity == 1) {
        return;
      }
      this.$emit('update-qty', this.quantity-1);
    },
    increaseQuantity() {
      this.$emit('update-qty', this.quantity+1);
    }
  }
}
</script>

<style scoped>
.mr-neg1 {
  margin-right: -1px;
}
</style>
